<ng-container *ngFor="let toast of toastService.toasts; let i = index">
  <app-toast [toast]="toast" [index]="i"></app-toast>
</ng-container>
